module.exports = __webpack_public_path__ + "static/media/boxOnPlane1.92b148cd.svg";